import axios from "axios";

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://adits-notesapp.herokuapp.com";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
});

export default api;
